module.exports = require('./isDefined')
